var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',{staticClass:"about image-composition"},_vm._l((_vm.images),function(img){return _c('img',{attrs:{"src":_vm.transformImage(img.image, 1.5),"alt":img.image.alt}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }